import React from "react";
import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";
import CollapsibleWrapper from "../CollapsibleWrapper";

const HumanMessageContent = ({
  msg,
  messageId,
  initialExpanded,
  onToggle,
  shouldCollapseByValue,
  renderCopyButton,
  convertExpertCommandsToDisplayNames,
  styles,
}) => {
  const displayContent = convertExpertCommandsToDisplayNames(msg.context);

  const renderAttachments = () => {
    if (!msg.attachments || msg.attachments.length === 0) return null;

    const getFileIcon = (fileName) => {
      const extension = fileName.split(".").pop().toLowerCase();
      switch (extension) {
        case "pdf":
          return "📕";
        case "doc":
        case "docx":
          return "📘";
        case "txt":
          return "📝";
        case "md":
          return "📋";
        default:
          return "📄";
      }
    };

    return (
      <div className="messageAttachments">
        {msg.attachments.map((attachment, attachmentIndex) => (
          <div key={attachmentIndex} className="attachmentItem">
            <span className="attachmentIcon">{getFileIcon(attachment.name)}</span>
            <span className="attachmentName">{attachment.name}</span>
            <span className="attachmentSize">
              ({(attachment.size / 1024).toFixed(1)} KB)
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={`message-content-wrapper ${styles.messageContentWrapper || ""}`}>
      <CollapsibleWrapper
        messageId={messageId}
        collapsible={shouldCollapseByValue(displayContent)}
        initialExpanded={initialExpanded}
        onToggle={onToggle}
      >
        <div className={styles.humanMessageContent}>
          <ReactMarkdown
            remarkPlugins={[remarkMath]}
            rehypePlugins={[[rehypeKatex, { throwOnError: false, strict: "ignore" }]]}
            components={{
              p: ({ children }) => <span style={{ margin: 0 }}>{children}</span>,
            }}
          >
            {displayContent}
          </ReactMarkdown>
          {renderAttachments()}
        </div>
      </CollapsibleWrapper>
      {renderCopyButton(displayContent)}
    </div>
  );
};

export default React.memo(HumanMessageContent);
